"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.i18nRegistrationInstance = void 0;
var i18next_1 = __importDefault(require("i18next"));
var RegistrationDictionaries_1 = require("./RegistrationDictionaries");
var SharedDictionaries_1 = require("../SharedDictionaries");
exports.i18nRegistrationInstance = i18next_1.default.createInstance({
    fallbackLng: 'en',
    ns: ['bluiRegistration', 'bluiCommon'],
    defaultNS: 'bluiRegistration',
    load: 'languageOnly',
    detection: {
        order: ['querystring', 'localStorage', 'navigator'],
        caches: ['localStorage'],
    },
    react: { useSuspense: false },
    interpolation: { escapeValue: false },
    resources: {
        en: {
            bluiRegistration: __assign({}, RegistrationDictionaries_1.RegistrationDictionaries.english.translation),
            bluiCommon: __assign({}, SharedDictionaries_1.SharedDictionaries.english.translation),
        },
        fr: {
            bluiRegistration: __assign({}, RegistrationDictionaries_1.RegistrationDictionaries.french.translation),
            bluiCommon: __assign({}, SharedDictionaries_1.SharedDictionaries.french.translation),
        },
        es: {
            bluiRegistration: __assign({}, RegistrationDictionaries_1.RegistrationDictionaries.spanish.translation),
            bluiCommon: __assign({}, SharedDictionaries_1.SharedDictionaries.spanish.translation),
        },
        zh: {
            bluiRegistration: __assign({}, RegistrationDictionaries_1.RegistrationDictionaries.chinese.translation),
            bluiCommon: __assign({}, SharedDictionaries_1.SharedDictionaries.chinese.translation),
        },
        pt: {
            bluiRegistration: __assign({}, RegistrationDictionaries_1.RegistrationDictionaries.portuguese.translation),
            bluiCommon: __assign({}, SharedDictionaries_1.SharedDictionaries.portuguese.translation),
        },
    },
}, 
// We must provide a function as second parameter, otherwise i18next errors
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function (err, _t) {
    // eslint-disable-next-line no-console
    if (err)
        return console.log(err);
});
exports.default = { i18nRegistrationInstance: exports.i18nRegistrationInstance };
